module.exports = __webpack_public_path__ + "4ce36c01ae724854fddcfb4339caf3ba.svg";